exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-3eec0{width:100%;max-width:600px}.yellowGroup-bcadd{display:inline-block;margin-left:6px}", ""]);

// Exports
exports.locals = {
	"form": "form-3eec0",
	"yellowGroup": "yellowGroup-bcadd"
};